import { render, staticRenderFns } from "./CollegeAdminAdd.vue?vue&type=template&id=eb97de5a&scoped=true&"
import script from "./CollegeAdminAdd.vue?vue&type=script&lang=js&"
export * from "./CollegeAdminAdd.vue?vue&type=script&lang=js&"
import style0 from "./CollegeAdminAdd.vue?vue&type=style&index=0&id=eb97de5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb97de5a",
  null
  
)

export default component.exports